"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/**
 * @file: description
 * @author: yangqianjun
 * @Date: 2019-07-20 15:12:00
 * @LastEditors: yangqianjun
 * @LastEditTime: 2019-12-20 09:43:44
 */
var createModel_1 = tslib_1.__importDefault(require("./createModel"));
tslib_1.__exportStar(require("./useModel"), exports);
tslib_1.__exportStar(require("./cm"), exports);
exports.default = createModel_1.default;
//# sourceMappingURL=index.js.map